// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-page {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
}

.uip-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 30px;
}

.uip-breadcrumb .current {
    font-weight: bold;
    color: #333;
}

.mp-header {
    display: flex;
    align-items: baseline;
    gap: 15px;
    margin-bottom: 40px;
    border-bottom: 2px solid #333;
    padding-bottom: 20px;
}

.mp-title {
    font-size: 28px;
    font-weight: bold;
    margin: 0;
}

.mp-customer-code {
    font-size: 16px;
    color: #555;
    margin: 0;
}

.mp-info-section {
    margin-bottom: 50px;
}

.mp-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.mp-section-header h2 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    border-left: 4px solid #d9534f;
    padding-left: 10px;
}

.mp-section-header p {
    font-size: 14px;
    color: #888;
    margin: 0;
}

.mp-info-grid {
    border-top: 2px solid #333;
    border-bottom: 1px solid #ccc;
}

.mp-info-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    align-items: center;
    border-bottom: 1px solid #eee;
    font-size: 15px;
}

.mp-info-row:last-child {
    border-bottom: none;
}

.mp-info-row .label {
    background-color: #f9f9f9;
    font-weight: bold;
    padding: 15px;
    color: #333;
    border-right: 1px solid #eee;
}

.mp-info-row span:last-child,
.mp-info-row button {
    padding: 15px;
}

.mp-manage-btn, .mp-edit-btn {
    background-color: #E84100;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(232, 65, 0, 0.2);
}

.mp-manage-btn:hover, .mp-edit-btn:hover {
    background-color: #d73502;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(232, 65, 0, 0.3);
}

.mp-manage-btn:active, .mp-edit-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(232, 65, 0, 0.2);
}

.mp-action-btn-light,
.mp-action-btn-dark {
    padding: 8px 20px;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    margin-left: 10px;
}

.mp-action-btn-light {
    background-color: white;
    border: 1px solid #ccc;
    color: #333;
}

.mp-action-btn-dark {
    background-color: #333;
    border: 1px solid #333;
    color: white;
}

.uip-main-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 60px;
}

.uip-progress-indicator {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin: 80px auto;
    position: relative;
    max-width: 600px;
}

.uip-progress-indicator::before, .uip-progress-indicator::after {
    content: '';
    position: absolute;
    top: 12px;
    left: 0;
    height: 3px;
    background-color: #eee;
    width: 100%;
    z-index: 0;
}

.uip-progress-indicator::after {
    background-color: #E84100;
    width: 0;
    z-index: 1;
    transition: width 0.3s ease-in-out;
}

.uip-progress-indicator.step-2::after { width: 50%; }
.uip-progress-indicator.step-3::after { width: 100%; }

.uip-progress-indicator .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ccc;
    font-weight: 500;
    position: relative;
    z-index: 2;
    width: 200px;
}

.uip-progress-indicator .step-item.active { color: #222; }

.uip-progress-indicator .circle {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #eee;
    margin-bottom: 20px;
    border: 3px solid #eee;
    box-sizing: border-box;
    transition: background-color 0.3s, border-color 0.3s;
}

.uip-progress-indicator .step-item.active .circle {
    background-color: #E84100;
    border-color: #E84100;
}

.uip-step-container {
    max-width: 900px;
    margin: 40px auto;
}

/* Step 1 Styles */
.uip-form-grid {
    border-top: 2px solid #222;
}

.uip-form-row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.uip-form-row label {
    flex-basis: 200px;
    padding: 20px;
    background-color: #f8f8f8;
    font-weight: 500;
}

.uip-required {
    color: #E84100;
    margin-left: 4px;
}

.uip-form-field {
    flex-grow: 1;
    padding: 10px 20px;
    display: flex;
    align-items: center;
}
.uip-form-field.static {
    gap: 20px;
}

.uip-form-field input[type="text"], .uip-form-field input[type="email"] {
    width: 100%;
    max-width: 300px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.uip-id-note {
    font-size: 14px;
    color: #888;
}

.uip-inline-btn {
    margin-left: 10px;
    padding: 10px 20px;
    background-color: #222;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.uip-actions {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    gap: 20px;
}

.uip-actions.space-between {
    justify-content: space-between;
}

.uip-confirm-btn-large {
    width: 100%;
    max-width: 300px;
    padding: 15px;
    font-size: 18px;
    background-color: #E84100;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}

.uip-summary-grid {
    border-top: 2px solid #222;
}

.uip-summary-row {
    display: flex;
    border-bottom: 1px solid #eee;
}
.uip-summary-row .label {
    flex-basis: 200px;
    padding: 20px;
    background-color: #f8f8f8;
    font-weight: 500;
}
.uip-summary-row span:last-child {
    flex-grow: 1;
    padding: 20px;
}


.uip-back-btn, .uip-confirm-btn {
    padding: 15px 60px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
}
.uip-back-btn {
    background-color: #f8f8f8;
    border: 1px solid #ccc;
    color: #222;
}
.uip-confirm-btn {
    background-color: #E84100;
    border: 1px solid #E84100;
    color: white;
}


.uip-step-container.centered-content {
    text-align: center;
    padding: 80px 0;
}
.uip-final-title {
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 40px;
}
.uip-black-btn {
    background-color: #222;
    color: white;
    border: none;
    padding: 15px 60px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .my-page {
        padding: 15px;
    }

    .mp-info-row {
        grid-template-columns: 150px 1fr;
    }

    .uip-form-row label {
        flex-basis: 150px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .mp-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding-bottom: 15px;
        margin-bottom: 30px;
    }

    .mp-title {
        font-size: 24px;
    }

    .mp-customer-code {
        font-size: 14px;
    }

    .mp-section-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }

    .mp-info-row {
        grid-template-columns: 1fr;
    }

    .mp-info-row .label {
        background-color: transparent;
        padding: 10px 0;
        border-right: none;
        border-bottom: 1px solid #eee;
    }

    .mp-info-row span:last-child, .mp-info-row button {
        padding: 15px 0;
    }

    .mp-manage-btn {
        width: 100%;
        padding: 12px;
    }

    .uip-progress-indicator {
        margin: 40px auto;
    }

    .uip-progress-indicator .step-item {
        font-size: 12px;
        width: auto;
    }
    
    .uip-progress-indicator .circle {
        width: 20px;
        height: 20px;
    }

    .uip-form-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .uip-form-row label {
        padding: 10px 0;
        width: 100%;
        flex-basis: auto;
    }

    .uip-form-field {
        padding: 10px 0;
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }

    .uip-form-field input[type="text"], .uip-form-field input[type="email"] {
        max-width: 100%;
    }

    .uip-inline-btn {
        margin-left: 0;
        margin-top: 10px;
        width: 100%;
    }
    
    .uip-actions.space-between {
        flex-direction: column-reverse;
    }

    .uip-back-btn, .uip-confirm-btn {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/MyPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,4BAA4B;AAChC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,kCAAkC;AACtC;;AAEA,wCAAwC,UAAU,EAAE;AACpD,wCAAwC,WAAW,EAAE;;AAErD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA,4CAA4C,WAAW,EAAE;;AAEzD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".my-page {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n}\n\n.uip-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 30px;\n}\n\n.uip-breadcrumb .current {\n    font-weight: bold;\n    color: #333;\n}\n\n.mp-header {\n    display: flex;\n    align-items: baseline;\n    gap: 15px;\n    margin-bottom: 40px;\n    border-bottom: 2px solid #333;\n    padding-bottom: 20px;\n}\n\n.mp-title {\n    font-size: 28px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.mp-customer-code {\n    font-size: 16px;\n    color: #555;\n    margin: 0;\n}\n\n.mp-info-section {\n    margin-bottom: 50px;\n}\n\n.mp-section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.mp-section-header h2 {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n    border-left: 4px solid #d9534f;\n    padding-left: 10px;\n}\n\n.mp-section-header p {\n    font-size: 14px;\n    color: #888;\n    margin: 0;\n}\n\n.mp-info-grid {\n    border-top: 2px solid #333;\n    border-bottom: 1px solid #ccc;\n}\n\n.mp-info-row {\n    display: grid;\n    grid-template-columns: 200px 1fr;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n    font-size: 15px;\n}\n\n.mp-info-row:last-child {\n    border-bottom: none;\n}\n\n.mp-info-row .label {\n    background-color: #f9f9f9;\n    font-weight: bold;\n    padding: 15px;\n    color: #333;\n    border-right: 1px solid #eee;\n}\n\n.mp-info-row span:last-child,\n.mp-info-row button {\n    padding: 15px;\n}\n\n.mp-manage-btn, .mp-edit-btn {\n    background-color: #E84100;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    border-radius: 6px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 4px rgba(232, 65, 0, 0.2);\n}\n\n.mp-manage-btn:hover, .mp-edit-btn:hover {\n    background-color: #d73502;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(232, 65, 0, 0.3);\n}\n\n.mp-manage-btn:active, .mp-edit-btn:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(232, 65, 0, 0.2);\n}\n\n.mp-action-btn-light,\n.mp-action-btn-dark {\n    padding: 8px 20px;\n    font-size: 14px;\n    cursor: pointer;\n    border-radius: 4px;\n    margin-left: 10px;\n}\n\n.mp-action-btn-light {\n    background-color: white;\n    border: 1px solid #ccc;\n    color: #333;\n}\n\n.mp-action-btn-dark {\n    background-color: #333;\n    border: 1px solid #333;\n    color: white;\n}\n\n.uip-main-title {\n    font-size: 36px;\n    font-weight: bold;\n    margin-bottom: 60px;\n}\n\n.uip-progress-indicator {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    margin: 80px auto;\n    position: relative;\n    max-width: 600px;\n}\n\n.uip-progress-indicator::before, .uip-progress-indicator::after {\n    content: '';\n    position: absolute;\n    top: 12px;\n    left: 0;\n    height: 3px;\n    background-color: #eee;\n    width: 100%;\n    z-index: 0;\n}\n\n.uip-progress-indicator::after {\n    background-color: #E84100;\n    width: 0;\n    z-index: 1;\n    transition: width 0.3s ease-in-out;\n}\n\n.uip-progress-indicator.step-2::after { width: 50%; }\n.uip-progress-indicator.step-3::after { width: 100%; }\n\n.uip-progress-indicator .step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #ccc;\n    font-weight: 500;\n    position: relative;\n    z-index: 2;\n    width: 200px;\n}\n\n.uip-progress-indicator .step-item.active { color: #222; }\n\n.uip-progress-indicator .circle {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background-color: #eee;\n    margin-bottom: 20px;\n    border: 3px solid #eee;\n    box-sizing: border-box;\n    transition: background-color 0.3s, border-color 0.3s;\n}\n\n.uip-progress-indicator .step-item.active .circle {\n    background-color: #E84100;\n    border-color: #E84100;\n}\n\n.uip-step-container {\n    max-width: 900px;\n    margin: 40px auto;\n}\n\n/* Step 1 Styles */\n.uip-form-grid {\n    border-top: 2px solid #222;\n}\n\n.uip-form-row {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n}\n\n.uip-form-row label {\n    flex-basis: 200px;\n    padding: 20px;\n    background-color: #f8f8f8;\n    font-weight: 500;\n}\n\n.uip-required {\n    color: #E84100;\n    margin-left: 4px;\n}\n\n.uip-form-field {\n    flex-grow: 1;\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n}\n.uip-form-field.static {\n    gap: 20px;\n}\n\n.uip-form-field input[type=\"text\"], .uip-form-field input[type=\"email\"] {\n    width: 100%;\n    max-width: 300px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.uip-id-note {\n    font-size: 14px;\n    color: #888;\n}\n\n.uip-inline-btn {\n    margin-left: 10px;\n    padding: 10px 20px;\n    background-color: #222;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.uip-actions {\n    margin-top: 50px;\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n}\n\n.uip-actions.space-between {\n    justify-content: space-between;\n}\n\n.uip-confirm-btn-large {\n    width: 100%;\n    max-width: 300px;\n    padding: 15px;\n    font-size: 18px;\n    background-color: #E84100;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.uip-summary-grid {\n    border-top: 2px solid #222;\n}\n\n.uip-summary-row {\n    display: flex;\n    border-bottom: 1px solid #eee;\n}\n.uip-summary-row .label {\n    flex-basis: 200px;\n    padding: 20px;\n    background-color: #f8f8f8;\n    font-weight: 500;\n}\n.uip-summary-row span:last-child {\n    flex-grow: 1;\n    padding: 20px;\n}\n\n\n.uip-back-btn, .uip-confirm-btn {\n    padding: 15px 60px;\n    font-size: 18px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n}\n.uip-back-btn {\n    background-color: #f8f8f8;\n    border: 1px solid #ccc;\n    color: #222;\n}\n.uip-confirm-btn {\n    background-color: #E84100;\n    border: 1px solid #E84100;\n    color: white;\n}\n\n\n.uip-step-container.centered-content {\n    text-align: center;\n    padding: 80px 0;\n}\n.uip-final-title {\n    font-size: 28px;\n    font-weight: 500;\n    margin-bottom: 40px;\n}\n.uip-black-btn {\n    background-color: #222;\n    color: white;\n    border: none;\n    padding: 15px 60px;\n    font-size: 18px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .my-page {\n        padding: 15px;\n    }\n\n    .mp-info-row {\n        grid-template-columns: 150px 1fr;\n    }\n\n    .uip-form-row label {\n        flex-basis: 150px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .mp-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        padding-bottom: 15px;\n        margin-bottom: 30px;\n    }\n\n    .mp-title {\n        font-size: 24px;\n    }\n\n    .mp-customer-code {\n        font-size: 14px;\n    }\n\n    .mp-section-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n\n    .mp-info-row {\n        grid-template-columns: 1fr;\n    }\n\n    .mp-info-row .label {\n        background-color: transparent;\n        padding: 10px 0;\n        border-right: none;\n        border-bottom: 1px solid #eee;\n    }\n\n    .mp-info-row span:last-child, .mp-info-row button {\n        padding: 15px 0;\n    }\n\n    .mp-manage-btn {\n        width: 100%;\n        padding: 12px;\n    }\n\n    .uip-progress-indicator {\n        margin: 40px auto;\n    }\n\n    .uip-progress-indicator .step-item {\n        font-size: 12px;\n        width: auto;\n    }\n    \n    .uip-progress-indicator .circle {\n        width: 20px;\n        height: 20px;\n    }\n\n    .uip-form-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .uip-form-row label {\n        padding: 10px 0;\n        width: 100%;\n        flex-basis: auto;\n    }\n\n    .uip-form-field {\n        padding: 10px 0;\n        width: 100%;\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .uip-form-field input[type=\"text\"], .uip-form-field input[type=\"email\"] {\n        max-width: 100%;\n    }\n\n    .uip-inline-btn {\n        margin-left: 0;\n        margin-top: 10px;\n        width: 100%;\n    }\n    \n    .uip-actions.space-between {\n        flex-direction: column-reverse;\n    }\n\n    .uip-back-btn, .uip-confirm-btn {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
